import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { NavLink as Link, NavLinkProps as LinkProps } from "Components/Navigation";
import { isSuperUserSelector, newMessagesCountSelector, socialCollaborationPortalEnabledSelector } from "Utils/selectors";

export type PortalNavVariant = "minimized";

export interface PortalNavProps {
   className?: string,
   baseUrl?: string | undefined,
   variant?: PortalNavVariant,
   isMatchOverride?: LinkProps["isMatchOverride"],
   linkType?: LinkProps["linkType"],
}

const PortalNav: React.FC<PortalNavProps> = ({ className, baseUrl, variant, children, ...navLinkProps }) => {
   const isSuperUser = useSelector(isSuperUserSelector);
   const newMessagesCount = useSelector(newMessagesCountSelector);
   const socialCollaborationPortalEnabled = useSelector(socialCollaborationPortalEnabledSelector);
   const fixedBaseUrl = baseUrl || "";
   return (
      <nav className={classNames("portal-nav", { [`portal-nav-${variant}`]: !!variant }, className)}>
         <Link to={`${fixedBaseUrl}/main`} icon={Icons.Dashboard} {...navLinkProps}>Dashboard</Link>
         {
            socialCollaborationPortalEnabled || isSuperUser
               ? <Link to={`${fixedBaseUrl}/social`} icon={Icons.Members} {...navLinkProps}>Team Connect</Link>
               : null
         }
         {/* Search page is legacy SRP, thus this link always navigates to it */}
         <Link to={"/search"} icon={Icons.Find} linkType={"direct"} isMatchOverride={navLinkProps.isMatchOverride}>Search</Link>
         <Link to={`${fixedBaseUrl}/collections`} icon={Icons.Like} {...navLinkProps}>Collections</Link>
         <Link to={`${fixedBaseUrl}/reservations`} icon={Icons.Calendar} {...navLinkProps}>Reservations</Link>
         <Link to={`${fixedBaseUrl}/messages`} counter={newMessagesCount} icon={Icons.Chat} {...navLinkProps}>Messages</Link>
         <Link to={`${fixedBaseUrl}/settings`} icon={Icons.Settings} {...navLinkProps}>Settings</Link>
         <Link to={`${fixedBaseUrl}/help`} icon={Icons.Help} {...navLinkProps}>Help</Link>
      </nav>
   )
}

export default PortalNav;